export default function LoadingSubmit() {
    return (
        <div className="spinner-container-submit">
            <div className="spinner"></div>
        </div>
    );
}